/**
 * file: seed.js
 * =====================================================================
 * Custom js
 */

const monthNames = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

/**
 * Blog Page
 * =====================================================================
 */
(function () {
  const dropdownBtn = document.querySelector(".blog-dropdown__btn");

  if (dropdownBtn) {
    dropdownBtn.addEventListener("click", () => {
      const value = document.getElementById("blog-dropdown-linklist").value;
      document.location.href = value;
    });
  }
})();

/**
 * Due Date Calculator
 * =====================================================================
 */

class DueDateCalculator extends HTMLElement {
  constructor() {
    super();

    this.selectors = {
      form: "[js-form]",
      result: "[js-result]",
      submit: "[js-due-date-submit]",
      error: "[js-error]",
      date: "[js-date]",
      reset: "[js-reset]",
      inputs: {
        calculationMethod: "[js-method-input]",
        lastPeriod: "[js-last-period-input]",
        cycleLenth: "[js-cycle-length-input]",
      },
    };
  }

  connectedCallback() {
    this.style.display = "none";
    const triggers = document.querySelectorAll(this.dataset.trigger);
    const submit = this.querySelector(this.selectors.submit);
    const reset = this.querySelector(this.selectors.reset);

    submit.addEventListener("click", this.onSubmit);
    reset.addEventListener("click", this.onReset);
    triggers.forEach((trigger) =>
      trigger.addEventListener("click", this.toggleVisisbility)
    );
  }

  toggleVisisbility = () => {
    if (this.style.display === "none") {
      this.style.display = "block";
    } else {
      this.style.display = "none";
    }
  };

  onSubmit = (e) => {
    e.preventDefault();
    this.hideError();
    this.selectInputs();

    const { calculationMethod, lastPeriod, cycleLenth } = this.inputs;
    if (this.validateInputs()) {
      const date = this.calculateDueDate(
        calculationMethod.value,
        lastPeriod.value,
        cycleLenth.value
      );

      this.renderDate(date);
      this.fillOutsideInputs(date);
    }
  };

  onReset = () => {
    const form = this.querySelector(this.selectors.form);
    const result = this.querySelector(this.selectors.result);

    form.style.display = "block";
    result.style.display = "none";
  };

  calculateDueDate(method, baseDate, cycleLength) {
    const result = new Date(new Date(baseDate));
    const offset = cycleLength - 28;

    switch (method) {
      case "last-period":
        result.setDate(result.getDate() + (280 + offset));
        break;
      case "conception-date":
        result.setDate(result.getDate() + (294 + offset));
        break;
      case "ivf":
        result.setDate(result.getDate() + (266 + offset));
        break;
    }

    return result;
  }

  renderDate(date) {
    const form = this.querySelector(this.selectors.form);
    const result = this.querySelector(this.selectors.result);
    const dateEl = this.querySelector(this.selectors.date);

    dateEl.textContent = `${
      monthNames[date.getMonth()]
    } ${date.getDate()}, ${date.getFullYear()}`;
    form.style.display = "none";
    result.style.display = "block";
  }

  fillOutsideInputs(date) {
    // if (this.dataset.monthInputSelector) {
    //   document
    //     .querySelectorAll(this.dataset.monthInputSelector)
    //     .forEach((input) => (input.value = date.getMonth() + 1));
    // }

    // if (this.dataset.dayInputSelector) {
    //   document
    //     .querySelectorAll(this.dataset.dayInputSelector)
    //     .forEach((input) => (input.value = date.getDate()));
    // }

    // if (this.dataset.yearInputSelector) {
    //   document
    //     .querySelectorAll(this.dataset.yearInputSelector)
    //     .forEach((input) => $(input).val(date.getFullYear()).trigger('change'));
    // }

    // set date
    const formattedDate = date.toISOString().replace(/T.*/,'').split('-').join('-');
    $("#expected-date").datetextentry('set_date', formattedDate);
  }

  selectInputs() {
    const lastPeriod = this.querySelector(this.selectors.inputs.lastPeriod);
    const cycleLenth = this.querySelector(this.selectors.inputs.cycleLenth);
    const calculationMethod = this.querySelector(
      this.selectors.inputs.calculationMethod
    );

    this.inputs = {
      calculationMethod,
      lastPeriod,
      cycleLenth,
    };
  }

  validateInputs() {
    if (!this.inputs.lastPeriod.value) {
      this.error("Please fill the first day of your last period");
      return false;
    }

    return true;
  }

  hideError() {
    this.querySelector(this.selectors.error).style.display = "none";
  }

  error(message) {
    const error = this.querySelector(this.selectors.error);
    error.style.display = "block";
    error.textContent = message;
  }
}

customElements.define("due-date-calculator", DueDateCalculator);
